export class ErrorWithStatusCode extends Error {
	public statusCode: string | number;

	constructor(message: string, options: ErrorOptions, statusCode: string | number) {
		super(message, options);
		this.statusCode = statusCode;
	}
}
